import SearchProgress from '@Services/SearchProgress';
import { batchSearchProgressModalReducerKey } from './BatchSearchProgressModalConstants';

export const batchSearchProgressModal = (state) => {
  return state.get(batchSearchProgressModalReducerKey);
};

export const singleDatabase = (state) => {
  return batchSearchProgressModal(state).get('singleDatabase');
};

export const queryRunning = (state) => {
  return batchSearchProgressModal(state).get('queryRunning');
};

export const status = (state) => {
  return batchSearchProgressModal(state).get('status');
};

export const progressPercentage = (state) => {
  return batchSearchProgressModal(state).get('progressPercentage');
};

export const progressStatus = (state) => {
  return batchSearchProgressModal(state).get('progressStatus');
};

export const queriesTotal = (state) => {
  return batchSearchProgressModal(state).get('queriesTotal');
};

export const currentDbName = (priorityWatcher) => {
  if (!priorityWatcher) {
    return null;
  }
  return SearchProgress && SearchProgress.getCurrentDbName(priorityWatcher);
};
